import { EventEmitter, Injectable } from "@angular/core";
import { CalcularDataModel } from "../../pages/simulador/core/domain/calcular.model";
import { AreaDataModel } from "../../pages/simulador/core/domain/area.model";
import { NivelAcademicosDataModel } from "../../pages/simulador/core/domain/nivelAcademico.model";
import { PeriodosDataModel } from "../../pages/simulador/core/domain/periodos.model";

export interface ResumenEmmiterData {
  area: AreaDataModel;
  calcular: CalcularDataModel;
  nivel: NivelAcademicosDataModel;
  periodo: PeriodosDataModel;
}

@Injectable({
  providedIn: "root",
})
export class EmmiterService {
  resumenEmmiter: EventEmitter<ResumenEmmiterData> =
    new EventEmitter<ResumenEmmiterData>();
  borrarFormulario: EventEmitter<any> = new EventEmitter<any>();
  reiniciarEmmiter: EventEmitter<any> = new EventEmitter<any>();
}
